import { getRequest, putRequest, postRequest, patchRequest } from "common/HttpClient/http-utility";
import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants";
import {
  GROUPS_FACILITIES_PICKER,
  GROUPS_LIST_PAGINATION,
} from "./Customers.constants";

export const CustomersServices = () => {
  const apiPaths = INFRAMARK_CONSTANTS.groups.services;
  const services = {
    getAllCustomers: async ({
      page = GROUPS_LIST_PAGINATION.DEFAULT_PAGE,
      size = GROUPS_LIST_PAGINATION.DEFAULT_PAGE_SIZE,
      name = "",
      code = "",
      isDeleted = "",
    } = {}) => {
      const params = { page, size };
      const nameQuery = String(name ?? "").trim();
      const codeQuery = String(code ?? "").trim();
      const isDeletedQuery = String(isDeleted ?? "").trim();

      if (nameQuery) {
        params.name = nameQuery;
      }
      if (codeQuery) {
        params.code = codeQuery;
      }
      if (isDeletedQuery === "true") {
        params.isDeleted = true;
      } else if (isDeletedQuery === "false") {
        params.isDeleted = false;
      }

      const response = await getRequest(apiPaths.groupsList, params);
      return response;
    },
    editCustomer: async (customerInfo) => {
      const identifier = customerInfo.code ?? customerInfo.customerCode;
      const response = await putRequest(`${apiPaths.editGroup}${identifier}`, customerInfo);
      return response
    },
    patchCustomer: async (customerInfo, code) => {
      const response = await patchRequest(`${apiPaths.patchGroup}${code}`, customerInfo);
      return response
    },
    addNewCustomer: async (customerInfo) => {
      const response = await postRequest(apiPaths.createGroup, customerInfo);
      return response
    },

    checkCustomerExists: async ({ name, code } = {}) => {
      const params = {};
      const nameQuery = String(name ?? "").trim();
      const codeQuery = String(code ?? "").trim();
      if (nameQuery) {
        params.name = nameQuery;
      }
      if (codeQuery) {
        params.code = codeQuery;
      }
      if (Object.keys(params).length === 0) {
        return { data: { exists: false, message: null, field: null } };
      }
      const response = await getRequest(apiPaths.customersExists, params);
      if (response?.error) {
        return { error: response.error || "Unable to verify customer." };
      }
      const payload = response?.data?.response ?? response?.data ?? {};
      return {
        data: {
          exists: Boolean(payload?.exists),
          message:
            typeof payload?.message === "string" ? payload.message : null,
          field: payload?.field ?? null,
        },
      };
    },

    patchModuleAccess: async (moduleKey, payload, customerCode) => {
      const encoded = encodeURIComponent(moduleKey);
      const response = await patchRequest(
        `${apiPaths.patchGroup}${customerCode}/module-access/${encoded}`,
        payload
      );
      return response;
    },

    patchCustomerDataConnections: async (customerCode, payload) => {
      // WMP-2395: path is the canonical customer code (PATCH /customers/{code}).
      const response = await patchRequest(
        `${apiPaths.patchGroup}${customerCode}`,
        payload
      );
      return response;
    },
    getHachwimsFacilityOptions: async ({
      text,
      page = GROUPS_FACILITIES_PICKER.DEFAULT_PAGE,
      size = GROUPS_FACILITIES_PICKER.PAGE_SIZE,
    } = {}) => {
      const params = { page, size };
      const searchValue = text ? text?.trim() : "";
      if (searchValue) params.name = searchValue;
      const response = await getRequest(apiPaths.hachwimsFacilityOptions, params);
      return response;
    },
  };
  return services;
};
